import styled from 'styled-components';

import { YatSprite } from '@pkg/components';

export const Wrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 3px;

    color: rgba(255, 255, 255, 0.5);
    font-size: 12px;
    font-weight: 600;

    span {
        color: #fff;
        font-size: 14px;
        font-weight: 700;
    }
`;

export const StyledYatSprite = styled(YatSprite)`
    width: 22px;
    height: 22px;
`;
